import React from "react";

import classes from "./PricingFeaturesList.module.scss";

interface PricingFeaturesList {
   features: React.ReactNode[];
}

const PricingFeaturesList: React.FC<PricingFeaturesList> = ({ features }) => {
   return (
      <ul className={classes.pricingList}>
         {features.map((feature, i) => (
            <li key={i} className={classes.pricingItem}>
               {feature}
            </li>
         ))}
      </ul>
   );
};

export default PricingFeaturesList;
